import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthOperadora } from '@shared/services/auth/AuthOperadora';
import { JwtAuthService } from '@shared/services/auth/jwt-auth.service';
import { environment } from 'environments/environment';
import { Observable, Subject, Subscriber, tap } from 'rxjs';
import { AnyCatcher } from 'rxjs/internal/AnyCatcher';


const urlView = 'view_usuarios';
const urlUsuarios = 'usuarios';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  public cacheStore = {
    filter: '', objFilter: {}, data: {list: [], totalPages: 0, totalCount: 0, pageIndex: 0}
  }

  constructor(
    private http: HttpClient
  ) { }

  getUsuarios(filter: any, objFilter: any): Observable<any> {
    var subject = new Subject<any>();
    this.http
    .get<any>(`${environment.apiURL}${urlView}?sort=-id${AuthOperadora.FILTER()}${filter}`, {observe: 'response'})
    .subscribe((resp: any) => {
      subject.next({
        'list':resp.body, 
        'totalPages':resp.headers.get('x-pagination-page-count'),
        'totalCount':resp.headers.get('x-pagination-total-count')
      })
    });
    return subject.asObservable().pipe(
      tap(
        (a: any) => {
          this.cacheStore.data = a;
          this.cacheStore.filter = filter;
          this.cacheStore.objFilter = objFilter;
          this.cacheStore.data.pageIndex = objFilter?.pageIndex;
        }
      )
    );
  }
  

  getUsuario(id: any): Observable<any> {
    return this.http.get(`${environment.apiURL}${urlView}/${id}`, { observe: 'body' });
  }

  setUsuario(usuario: any): Observable<any> {
    return this.http.post(`${environment.apiURL}${urlUsuarios}`, usuario).pipe(
      tap(
        () => {
          this.cacheStore.data.list = [];
        }
      )
    );
  }

  updateUsuario(usuario: any): Observable<any> {
    return this.http.put(`${environment.apiURL}${urlUsuarios}/${usuario.id}`, usuario).pipe(
      tap(
        () => {
          this.cacheStore.data.list = [];
        }
      )
    );
  }

  delUsuario(id_usuario: number): Observable<any> {
    return this.http.delete(
      `${environment.apiURL}${urlUsuarios}/${id_usuario}`
    );
  }

  getGrupos(): Observable<any> {
    return this.http.get(
      `${environment.apiURL}auth_groups?sort=id`, { observe: 'body' }
    );
  }


  getGruposUsuario(user_id: number): Observable<any> {
    return this.http.get(
      `${environment.apiURL}view_permisos_grupo_usuarios?sort=group_id&filter[user_id]=${user_id}`, { observe: 'body' }
    );
  }

  getPermisosUsuario(id_usuario:number): Observable<any> {
    return this.http.get(
      `${environment.apiURL}auth_user_groups?sort=id&filter[user_id]=${id_usuario}`, { observe: 'body' }
    );

  }

  getEmpresaResponsableUser(user_id: number): Observable<any>{
    return this.http.get(
      `${environment.apiURL}view_user_responsables/${user_id}`, { observe: 'body' }
    );
  }
  getViewPermisos(user_id: number){
    return this.http.get(`${environment.apiURL}view_permisos_individuales_usuarios?filter[user_id]=${user_id}`)
  }


  getRolesDisponibles(){
    return this.http.get(`${environment.apiURL}auth_groups`);
    }


    generarExcel(data: any): Observable<any> {
      return this.http.post(`${environment.apiURL}generate_excels/usuarios`, data);
    }

    cambiarMiPassword(input:any): Observable<any> {
      return this.http.put(
        `${environment.apiURL}password`, input
      );
    }

}
